<template>
  <div class="language-switcher">
    <button
      v-for="lang in languages"
      :key="lang.locale"
      class="lang-btn"
      :class="{ active: currentLocale === lang.locale }"
      @click="switchLocale(lang.locale)"
    >
      <svg class="flag-svg" viewBox="0 0 20 14" xmlns="http://www.w3.org/2000/svg" v-html="lang.flagSvg" />
      <span class="code">{{ lang.code }}</span>
    </button>
  </div>
</template>

<script>
import { setLocale, getCurrentLocale } from '@/i18n'

const FLAG_ES = `
  <rect width="20" height="14" fill="#c60b1e"/>
  <rect y="3.5" width="20" height="7" fill="#ffc400"/>
`

const FLAG_PT = `
  <rect width="20" height="14" fill="#d52b1e"/>
  <rect width="8" height="14" fill="#006600"/>
  <circle cx="8" cy="7" r="2.5" fill="none" stroke="#ffd700" stroke-width="0.7"/>
  <circle cx="8" cy="7" r="1.5" fill="#fff" opacity="0.9"/>
`

export default {
  name: 'LanguageSwitcher',
  data() {
    return {
      languages: [
        { locale: 'es-ES', code: 'ES', flagSvg: FLAG_ES },
        { locale: 'pt-PT', code: 'PT', flagSvg: FLAG_PT },
      ],
    }
  },
  computed: {
    currentLocale() {
      return getCurrentLocale()
    },
  },
  methods: {
    switchLocale(locale) {
      setLocale(locale)
    },
  },
}
</script>

<style scoped>
.language-switcher {
  display: flex;
  align-items: center;
  gap: 2px;
  margin-right: 12px;
  background: rgba(255, 255, 255, 0.12);
  border-radius: 20px;
  padding: 2px;
}

.lang-btn {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 4px 10px;
  border: none;
  border-radius: 18px;
  cursor: pointer;
  background: transparent;
  color: rgba(255, 255, 255, 0.75);
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  transition: background 0.2s, color 0.2s;
  line-height: 1;
}

.lang-btn:hover:not(.active) {
  background: rgba(255, 255, 255, 0.15);
  color: #fff;
}

.lang-btn.active {
  background: #fff;
  color: #DF0024;
}

.flag-svg {
  width: 20px;
  height: 14px;
  border-radius: 2px;
  flex-shrink: 0;
  display: block;
  overflow: hidden;
}

.code {
  font-size: 11px;
}
</style>
